import {useState, useEffect} from "react";
import {SwalAlertClass} from "core/swalClass";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";
import {Doughnut} from "react-chartjs-2";
import axiApi from "ApiCaller";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughtModels = () => {
  const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [colors, setColors] = useState([]);
  const [total, setTotal] = useState(0);
  const transparency = {
    sum: 0,
    value: 40,
  };
  const DataGraph = {
    labels: labels,
    datasets: [
      {
        label: "Número de modelos",
        data: data,
        backgroundColor: colors,
        hoverOffset: 10,
      },
    ],
  };

  const OptionsGraph = {
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          font: {
            size: 10,
          },
        },
      },
      title: {
        display: true,
        text: "Tipos de descarga",
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            let value = tooltipItem.raw;
            let percentage = ((value / total) * 100).toFixed(2);
            return `${tooltipItem.label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  useEffect(() => {
    axiApi
      .get("/api/home/containers/downloads/")
      .then((resp) => {
        if (resp.data.status) {
          let labels = [];
          let values = [];
          let backgroud = [];
          let total = 0;
          let names = {};
          transparency.sum = Math.trunc(
            (255 - 40) / resp.data.containers.length
          );
          resp.data.choices.forEach(([key, value]) => {
            names[key] = value;
          });

          resp.data.containers.forEach((waste, idx) => {
            labels.push(names[waste.download]);
            values.push(waste.count);
            backgroud.push(`#00a6de${transparency.value.toString(16)}`); // add transparency
            transparency.value += transparency.sum; // change transparency
            total += waste.count;
          });
          setLabels(labels);
          setData(values);
          setColors(backgroud);
          setTotal(total);
        } else {
          Alert.error(
            "Error in ContainerFraction.API",
            "Se ha encontrado un error en la carga del mapa."
          );
        }
      })
      .catch((error) => {
        console.log(error);
        Alert.error(
          "Error in ContainerFraction.API",
          "Se ha encontrado un error en la carga del mapa."
        );
      });
  }, []);

  return (
    <div className="border pb-3">
      <Doughnut data={DataGraph} options={OptionsGraph} />
    </div>
  );
};

export default DoughtModels;
